// Utils
import { isLocationCanvas } from '../../../common/elements/utils/elementLocationUtils';

// Constants
import { IN_LIST_MODE } from '../../../common/inList/listTypes';

export const getShowQuickLineTool = ({ isSingleSelected, element, inList, isEditable }) =>
    isSingleSelected && (isLocationCanvas(element) || inList === IN_LIST_MODE.IN_LIST_COLUMN) && isEditable;
